"use client"

import type { I18nLocale } from "@/modules/i18n/types"
import type { ComponentProps, FunctionComponent } from "react"

import { Filter } from "@jobteaser/spark/components/Icons/Filter"

import { TrackObfuscatedLink } from "@/modules/tracking/components/TrackObfuscatedLink"
import { ensureTrackingProps } from "@/modules/tracking/helpers/ensureTrackingProps"

type FilterJobOffersLinkProps = Omit<ComponentProps<typeof TrackObfuscatedLink>, "trackingProps"> & {
  locale: I18nLocale
  trackingRefIds: Record<string, string[]>
  trackingRole: string
  trackingSchoolId: string
  trackingVisualContext: string
}

export const FilterJobOffersLink: FunctionComponent<FilterJobOffersLinkProps> = ({
  children,
  locale,
  trackingRefIds,
  trackingRole,
  trackingSchoolId,
  trackingVisualContext,
  ...props
}) => {
  const { href } = props

  return (
    <TrackObfuscatedLink
      {...props}
      icon={Filter}
      trackingProps={ensureTrackingProps({
        eventName: "event_click",
        eventProperties: {
          clicked_url: href,
          ref_ids: trackingRefIds,
          role: `${trackingRole}-job-ad-filter`,
          service: "generic_fe",
          trackee_locale: locale,
          trackee_school_id: trackingSchoolId,
          visual_context: `${trackingVisualContext}-section-filter-button`,
        },
      })}
    >
      {children}
    </TrackObfuscatedLink>
  )
}
